import {
  AutocompleteApi,
  AutocompleteOptions,
  AutocompleteState,
  createAutocomplete
} from "@algolia/autocomplete-core";
import { useMemo, useState } from "react";
import { RenderListItem } from "../RefinementListFilter/RefinedListValues";
import { useClientSideFeatureFlag } from "src/utils/feature-flags";

// TODO: rename in AutocompleteState
export type UseAutocompleteState = AutocompleteState<RenderListItem>;
export type AutocompleteResult = AutocompleteApi<RenderListItem>;

export function useAutocomplete(props: AutocompleteOptions<RenderListItem>) {
  const [state, setState] = useState<UseAutocompleteState>(() => ({
    collections: [],
    completion: null,
    context: {},
    isOpen: false,
    query: "",
    activeItemId: null,
    status: "idle"
  }));
  const isCruiseTagEnabled = useClientSideFeatureFlag("cruiseTags");
  const autocomplete = useMemo(
    () =>
      createAutocomplete<
        RenderListItem,
        React.BaseSyntheticEvent,
        React.MouseEvent,
        React.KeyboardEvent
      >({
        ...props,
        //plugins,
        onStateChange(params) {
          const newState = params.state;

          if (!isCruiseTagEnabled) {
            console.log(newState.collections);
            newState.collections = newState.collections.filter(
              (c) => !c.source.sourceId.includes("cruiseTagsTree")
            );
          }
          setState(newState);
        }
      }),
    [isCruiseTagEnabled]
  );

  const hasResults = () =>
    state.collections.reduce((p, c) => p + c.items.length, 0) > 0;

  return { autocomplete, state, hasResults };
}
